<div class="map-holder">
    <google-map height="100%" width="100%" [center]="center" [zoom]="zoom" (mapClick)="onMapClick()"
        (mapMousemove)="move($event)" [options]="mapOptions">
        <!-- Vehicle Markers -->
        <map-marker *ngFor="let marker of markers" 
            [position]="marker.position"
            [title]="marker.title"
            [options]="marker.options"
            (mapClick)="onMarkerClick(marker, $event)">
        </map-marker>
    </google-map>

    <!-- Context Menu -->
    <div *ngIf="showContextMenu" class="context-menu" 
         [style.left.px]="contextMenuPosition.x"
         [style.top.px]="contextMenuPosition.y">
        <div class="context-menu-header">
            <h3>{{selectedMarker?.title}}</h3>
        </div>
        <div class="context-menu-content">
            <div class="context-menu-row">
                <span class="label">Status:</span>
                <span class="value" [style.color]="selectedMarker?.status === 'Active' ? '#28a745' : '#dc3545'" style="font-weight: 500;">{{selectedMarker?.status}}</span>
            </div>
            <!-- <div class="context-menu-row">
                <span class="label">Last Update:</span>
                <span class="value">2 minutes ago</span>
            </div> -->
            <div class="context-menu-row">
                <span class="label">Partner Vehicle Type</span>
                <span class="value">{{selectedMarker?.vehicleType}}</span>
            </div>
            <div class="context-menu-row">
                <span class="label">Services Registered: <br>
                    <span class="value">
                        <ng-container *ngIf="selectedMarker?.isOkRide || selectedMarker?.isExpress || selectedMarker?.isMototaxi">
                            <span *ngIf="selectedMarker?.isOkRide">Ok Ride</span>
                            <span *ngIf="selectedMarker?.isOkRide && (selectedMarker?.isExpress || selectedMarker?.isMototaxi)"> |
                            </span>
                            <span *ngIf="selectedMarker?.isExpress">Express</span>
                            <span *ngIf="selectedMarker?.isExpress && selectedMarker?.isMototaxi"> | </span>
                            <span *ngIf="selectedMarker?.isMototaxi">Mototaxi</span>
                        </ng-container>
                        <span *ngIf="!(selectedMarker?.isOkRide || selectedMarker?.isExpress || selectedMarker?.isMototaxi)">None</span>
                    </span>
                </span>
            </div>
            <div class="context-menu-row">
                <span class="label">Booking Status: <br>
                  <ng-container *ngIf="selectedMarker?.currentBooking; else noBooking">
                    <span class='stat stat-amend' *ngIf="selectedMarker.currentBooking.status === 'canceled'">Cancelled</span>
                    <span class='stat stat-active' *ngIf="selectedMarker.currentBooking.status === 'pending'">Pending</span>
                    <span class='stat stat-amend' *ngIf="selectedMarker.currentBooking.status === 'accepted'">Accepted</span>
                    <span class='stat stat-amend' *ngIf="selectedMarker.currentBooking.status === 'ongoing_pickup'">On Going Pickup</span>
                    <span class='stat stat-approved' *ngIf="selectedMarker.currentBooking.status === 'arrive_pickup'">Arrived Pickup</span>
                    <span class='stat stat-approved' *ngIf="selectedMarker.currentBooking.status === 'ongoing_destination'">Ongoing Destination</span>
                    <span class='stat stat-approved' *ngIf="selectedMarker.currentBooking.status === 'drop_off'">Drop Off</span>
                    <span class='stat stat-approved' *ngIf="selectedMarker.currentBooking.status === 'completed'">Completed</span>
                    <span class='stat stat-active' *ngIf="selectedMarker.currentBooking.status && 
                      selectedMarker.currentBooking.status !== 'canceled' && 
                      selectedMarker.currentBooking.status !== 'pending' && 
                      selectedMarker.currentBooking.status !== 'accepted' && 
                      selectedMarker.currentBooking.status !== 'ongoing_pickup' && 
                      selectedMarker.currentBooking.status !== 'arrive_pickup' && 
                      selectedMarker.currentBooking.status !== 'ongoing_destination' && 
                      selectedMarker.currentBooking.status !== 'drop_off' && 
                      selectedMarker.currentBooking.status !== 'completed'">
                      {{selectedMarker.currentBooking.status | titlecase}}
                    </span>
                  </ng-container>
                  <ng-template #noBooking>N/A</ng-template>
                </span>
              </div>

              <div class="context-menu-row" *ngIf="selectedMarker?.currentBooking">
                <span class="label">Transaction Link: <br>
                    <span class="value"><a href="{{selectedMarker?.hyperLinkUrlTrans}}" target="_blank" style="font-size: 11px; font-style: italic;">Click Here to View Transaction</a></span>
                </span>
              </div>
        </div>
        <!-- <div class="context-menu-actions">
            <button class="action-button" (click)="onContextMenuAction('viewDetails')">View Details</button>
            <button class="action-button" (click)="onContextMenuAction('trackLocation')">Track Location</button>
            <button class="action-button" (click)="onContextMenuAction('sendMessage')">Send Message</button>
        </div> -->
    </div>
</div>
